import React from 'react';
import { Link } from 'react-router-dom';

const BeneluxHero = () => (
  <section className="bg-gradient-to-br from-[#2F4E6F] to-[#1e3550] text-white py-20 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <div className="inline-block bg-[#FF8C00]/20 text-[#FF8C00] text-sm font-semibold px-4 py-1.5 rounded-full mb-6 border border-[#FF8C00]/30">
        Benelux Contract Generator
      </div>
      <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
        Freelance Contract Generator
        <span className="block text-[#FF8C00] mt-2">voor de Benelux</span>
      </h1>
      <p className="text-xl text-blue-100 mb-4 max-w-2xl mx-auto">
        Pactorae is speciaal ontworpen voor freelancers en ZZP'ers in België en Nederland. Genereer in 30 seconden een professioneel contract op maat — tweetalig en juridisch correct.
      </p>
      <p className="text-sm text-blue-200 mb-8 max-w-xl mx-auto">
        Geschikt voor zelfstandigen in België, zzp'ers in Nederland en alle freelancers in de Benelux-regio.
      </p>
      <Link
        to="/contract-generator"
        className="inline-block bg-[#FF8C00] hover:bg-[#e07b00] text-white font-semibold px-8 py-4 rounded-lg text-lg transition-colors duration-200 shadow-lg"
      >
        Genereer jouw contract gratis
      </Link>
    </div>
  </section>
);

export default BeneluxHero;
